import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  generatePersonSchema,
  generateWebSiteSchema,
  generateBreadcrumbSchema,
  generateOrganizationSchema,
} from '../utils/seo';

/**
 * StructuredData Component
 * Renders JSON-LD structured data for SEO
 * 
 * @param {string} type - Schema type (person, website, breadcrumb, organization, custom)
 * @param {object} customSchema - Custom schema object for type='custom'
 */
const StructuredData = ({ type = 'person', customSchema = null }) => {
  const getSchema = () => {
    switch (type) {
      case 'person':
        return generatePersonSchema();

      case 'website':
        return generateWebSiteSchema();

      case 'breadcrumb':
        return generateBreadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'About', path: '/about' },
          { name: 'Projects', path: '/projects' },
          { name: 'Contact', path: '/contact' },
        ]);

      case 'organization':
        return generateOrganizationSchema();

      case 'profile':
        return {
          '@context': 'https://schema.org',
          '@type': 'ProfilePage',
          mainEntity: generatePersonSchema(),
        };

      case 'custom':
        return customSchema;

      default:
        return null;
    }
  };

  const schema = getSchema();

  if (!schema) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
